var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgYii = function SvgYii(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.36 3c2.84 1.456 5.278 5.276 5.156 10.46-.371 6.387-4.973 11.892-9.98 16.964-.28-6.185-1.617-10.127-3.704-15.67C27.862 9.168 33.622 3.18 38.361 3Z",
    fill: "url(#yii_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.28 25.23c-.75 1.49-1.806 3.137-3.276 4.976-2.558 3.244-5.137 8.564-4.343 14.8 11.46-1.272 14.37-10.553 14.163-14.567l-.024-.27-.001-.002.025.271c-1.803-2.337-3.958-3.948-6.543-5.209Z",
    fill: "url(#yii_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.67 15.484c2.876 4.492 4.686 9.638 5.154 14.954-1.803-2.338-3.958-3.949-6.544-5.21 2.087-4.15 1.793-7.109 1.39-9.744Z",
    fill: "url(#yii_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.588 13.896c-5.073-6.94-13.861-10.27-22.026-7.018-.375 4.879 1.698 12.134 10.107 14.443.926.276 1.78.524 2.583.758 2.27.66 4.14 1.204 6.124 1.929 1.024.374 1.99.776 2.904 1.22 2.086-4.15 1.793-7.109 1.39-9.744 0 0-.885-1.318-1.082-1.588Z",
    fill: "url(#yii_svg__d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "yii_svg__a",
    x1: 36.478,
    y1: 3,
    x2: 36.478,
    y2: 30.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73B723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8EE61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yii_svg__b",
    x1: 30.666,
    y1: 30.299,
    x2: 17.049,
    y2: 40.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#026FB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086EB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yii_svg__c",
    x1: 28.306,
    y1: 20.119,
    x2: 34.067,
    y2: 22.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4C883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1D1A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yii_svg__d",
    x1: 4.52,
    y1: 6.874,
    x2: 22.162,
    y2: 22.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D73721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7D768"
  })))));
};

export default SvgYii;